import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";
import { TakingLongerPendingPresetComponent } from "@modules/+new/shared/universal-modal/components/_presets/taking-longer-pending-preset/taking-longer-pending-preset.component";

export const PendingTakingLongerPresetDefinition: OpenPresetModalDefinition<PendingData> = {
	component: TakingLongerPendingPresetComponent,
	options: {
		wrap: false,
		size: ModalSizes.lg,
		showCancel: false,
		showPrevious: false,
		cancelKey: "close",
		isPreset: PresetsComponentsEnum.pendingTakingLonger
	}
};
